var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMustPlayFilled(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 14.1219H12.5L14.7174 4.27959L11 6.625L8.01014 2.8913L5 6.625L1.28835 4.19106L3.5 14.1219Z",
    fill: "CURRENTCOLOR"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.65697 1.41781C6.65307 2.16012 7.30313 2.84717 8.01323 2.85125C8.72333 2.85532 9.38057 2.17554 9.38446 1.43323C9.38836 0.69091 8.7383 0.00409304 8.0282 1.82328e-05C7.3181 -0.00405658 6.66087 0.675491 6.65697 1.41781Z",
    fill: "CURRENTCOLOR"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4285 2.93219C13.4246 3.67451 13.9971 4.27958 14.7072 4.28365C15.4173 4.28773 15.9961 3.68927 16 2.94695C16.0039 2.20464 15.4314 1.59957 14.7213 1.59549C14.0112 1.59142 13.4324 2.18988 13.4285 2.93219Z",
    fill: "CURRENTCOLOR"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.97878e-05 2.84151C-0.00387819 3.58383 0.568613 4.1889 1.27871 4.19297C1.98882 4.19705 2.56763 3.59859 2.57152 2.85627C2.57542 2.11395 2.00293 1.50888 1.29283 1.50481C0.582729 1.50074 0.00391776 2.0992 1.97878e-05 2.84151Z",
    fill: "CURRENTCOLOR"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMustPlayFilled);
export default __webpack_public_path__ + "static/media/mustPlayFilled.86563404.svg";
export { ForwardRef as ReactComponent };